"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesPanel = exports.FEATURES_TYPES = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const LabeledIcon_1 = require("../../atoms/LabeledIcon");
const styled_components_1 = __importStar(require("styled-components"));
exports.FEATURES_TYPES = {
    models: ui_1.Icons.Gross_Anatomy_Models,
    heart: ui_1.Icons.Beating_Heart,
    motion: ui_1.Icons.Motion,
    surfaces: ui_1.Icons.Surfaces,
    origin: ui_1.Icons.Origin,
    innervation: ui_1.Icons.Arteries,
    io: ui_1.Icons.Io,
};
const featuresDict = i18n_1.Strings.store.feature;
function FeaturesPanel() {
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'FeaturesPanel_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'FeaturesPanel_Title', children: (0, i18n_1.Localized)(featuresDict.title) }), (0, jsx_runtime_1.jsx)(Content, { "data-e2e": 'FeaturesPanel_Content', children: Object.entries(exports.FEATURES_TYPES).map(([type, icon], i) => ((0, jsx_runtime_1.jsx)(StyledLabeledIcon, { name: icon, "data-e2e": 'FeaturesPanel_StyledLabeledIcon', children: (0, i18n_1.Localized)(featuresDict[type]) }, i))) })] }));
}
exports.FeaturesPanel = FeaturesPanel;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  width: 100%;

  margin: 40px 0 0 0;
`;
const Title = styled_components_1.default.div `
  margin: 0 auto 40px auto;

  color: ${props => props.theme.text};

  font-size: 20px;
  text-align: center;
`;
const Content = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  width: 100%;
  margin: 0;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    justify-content: center;

    max-width: 600px;

    margin: 0 auto;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    justify-content: center;

    max-width: 900px;

    margin: 20px auto;
  `)}
`;
const StyledLabeledIcon = (0, styled_components_1.default)(LabeledIcon_1.LabeledIcon).attrs({ 'aria-hidden': true }) `
  flex-basis: 50%;

  max-width: none;

  margin: 0 0 20px 0;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    flex-basis: 25%;

    margin: 0 0 40px 0;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    max-width: 125px;

    margin: 0 40px 40px 40px;
  `)};
`;
